import { accountIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const PromptSchema = z.object({
  id: z.bigint(),
  accountId: accountIdFormat.schema,
  prompt: z.string(),
  branded: z.boolean(),
  createdAt: z.date(),
  deletedAt: z.date().nullable(),
});
export type Prompt = z.infer<typeof PromptSchema>;

export const AeoPromptTopicSchema = z.object({
  id: z.bigint(),
  name: z.string(),
  color: z.string().nullable(),
});
export type AeoPromptTopic = z.infer<typeof AeoPromptTopicSchema>;
